module.exports = __webpack_public_path__ + "dist/assets/501df0dca2f28e703634a2c81140f3b2.svg";